import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { get } from "../../lib/request"

/** Map GET /clients/cities rows to inbox shape (`id` + display `city` label). */
export function normalizeAiCity(row) {
  if (!row || row.id == null) return null
  const name = String(row.name ?? "").trim()
  return {
    id: row.id,
    name,
    city: name,
    worldState: row.worldState ?? null,
    worldCountry: row.worldCountry ?? row.worldState?.worldCountry ?? null,
  }
}
function normalizeAiCitiesPayload(payload) {
  const raw = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.data)
      ? payload.data
      : Array.isArray(payload?.cities)
        ? payload.cities
        : []
  return raw.map(normalizeAiCity).filter(Boolean)
}

// GET /api/v1/clients/cities?clientIds=1&clientIds=2
export const fetchAiCities = createAsyncThunk(
  "citiesAi/fetch",
  async (clientIds = [], { rejectWithValue }) => {
    try {
      if (!clientIds || clientIds.length === 0) {
        return []
      }
      const params = clientIds.map((id) => `clientIds=${id}`).join("&")
      const data = await get(`clients/cities?${params}`)
      return normalizeAiCitiesPayload(data)
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to fetch cities")
    }
  }
)

const initialState = {
  cities: [],
  status: "idle", // idle | loading | succeeded | failed
  error: null,
}

const citiesAiSlice = createSlice({
  name: "citiesAi",
  initialState,
  reducers: {
    clearAiCities: (state) => {
      state.cities = []
      state.status = "idle"
      state.error = null
    },
    resetOnLogout: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAiCities.pending, (state) => {
        state.status = "loading"
      })
      .addCase(fetchAiCities.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.cities = action.payload || []
      })
      .addCase(fetchAiCities.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const { clearAiCities, resetOnLogout } = citiesAiSlice.actions
export default citiesAiSlice.reducer
